module.exports = __webpack_public_path__ + "static/media/banner-210909_1.9ff8b748.png";